module.exports = __webpack_public_path__ + "img/internet-explorer.ee5d6dec.svg";